import Vue from "vue";
require("./default.js");
import router from "../routes";
import store from "../store/modules/kycLogin.js";

// console.log("router",router[0])

// console.log("store",store.state)
// console.log("store",store.state.admin_partner)
Object.assign(Vue.config, {
  ATLANTIS_URL: "http://localhost:8887",
  // EL_DORADO_API_URL:  window.location.pathname.match(/ku/i)? "http://localhost:3000" : "https://staging-partner.kuvera.in" ,
  //  EL_DORADO_API_URL: window.location.pathname.match(/ku/i)? "https://api.kuvera.in" : "https://staging-partner.kuvera.in" ,
  EL_DORADO_API_URL: "https://api.kuvera.in" ,
  EL_DORADO_API_URL_BIGCO: "https://api-partner.kuvera.in",
  // EL_DORADO_API_URL_BIGCO: "https://amazon.kuvera.in",
  ENV: "development",
  ASSET_PATH: process.env.ASSET_PATH,
  LOGOUT_TIMEOUT: 30000 * 60 * 1000
});

